import { render, staticRenderFns } from "./tealiveness.vue?vue&type=template&id=36b297da&scoped=true"
import script from "./tealiveness.vue?vue&type=script&lang=js"
export * from "./tealiveness.vue?vue&type=script&lang=js"
import style0 from "./tealiveness.vue?vue&type=style&index=0&id=36b297da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b297da",
  null
  
)

export default component.exports